import React, { useState, useEffect } from 'react';
interface CountdownTimerProps {
  hours: number;
  className?: string;
}
const CountdownTimer = ({
  hours,
  className
}: CountdownTimerProps) => {
  const calculateTimeLeft = () => {
    const startTime = localStorage.getItem('countdown_start');
    let difference;
    if (startTime) {
      // If we have a stored start time, use it
      difference = +new Date(parseInt(startTime, 10)) + hours * 60 * 60 * 1000 - +new Date();
    } else {
      // Otherwise, set a new start time
      const now = new Date().getTime();
      localStorage.setItem('countdown_start', now.toString());
      difference = hours * 60 * 60 * 1000;
    }
    let timeLeft = {
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    if (difference > 0) {
      timeLeft = {
        hours: Math.floor(difference / (1000 * 60 * 60)),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      };
    }
    return timeLeft;
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });
  return (
    <div className={`text-center ${className || ''}`}>
      <div className="flex justify-center space-x-4 text-2xl font-bold text-white">
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 min-w-[60px]">
          <div>{String(timeLeft.hours).padStart(2, '0')}</div>
          <div className="text-xs text-purple-200 mt-1">Hours</div>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 min-w-[60px]">
          <div>{String(timeLeft.minutes).padStart(2, '0')}</div>
          <div className="text-xs text-purple-200 mt-1">Minutes</div>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 min-w-[60px]">
          <div>{String(timeLeft.seconds).padStart(2, '0')}</div>
          <div className="text-xs text-purple-200 mt-1">Seconds</div>
        </div>
      </div>
    </div>
  );
};
export default CountdownTimer;